import type { DocumentDetailPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';

export type DocumentListItemMovedAction = {
	type: 'DOCUMENT_LIST_ITEM_MOVED';
	payload: DocumentDetailPayload;
};

export default (payload: DocumentDetailPayload): DocumentListItemMovedAction => ({
	type: 'DOCUMENT_LIST_ITEM_MOVED',
	payload,
});
